import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from "@reduxjs/toolkit/query";
import {baseApi} from "../services/apiService";
import authSlice from "../slices/authSlice";
import limitGateSlice from "../slices/limitGateSlice";
import {rtkQueryLogger} from "../middleware/rtkQueryLogger";
import devSlice from "../slices/dev/devSlice";
import {rtkQueryNotifications} from "../middleware/rtkQueryNotifications";
import {sentryReduxMiddleware} from "../middleware/sentryReduxMiddleware";
import {authListenerMiddleware} from "../middleware/authPersistMiddleware";


export const store = configureStore({
    reducer: {
        auth: authSlice,
        limitGate: limitGateSlice,
        [baseApi.reducerPath]: baseApi.reducer,
        dev: devSlice,
    },
    middleware: (getDefaultMiddleware: any) =>
        getDefaultMiddleware()
            .prepend(authListenerMiddleware.middleware)
            .concat(baseApi.middleware, rtkQueryNotifications, rtkQueryLogger, sentryReduxMiddleware),
});

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
